import { useState } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';

import { OptInPage } from './OptInPage';

import { Layout } from '../../../InstitutionalApp/Layout';
import { Paginator } from '../../../paginator/Paginator';
import { ClientBillingHeader } from '../../ClientBillingHeader';
import { BulkFeeIntent } from '../data';
import { BulkFeeIntentsDocument } from '../graphql/query.bulk_fee_intents.generated';
import { BulkFeeIntentsTable } from '../table/BulkFeeIntentsTable';

const PAGE_SIZE = 20;

type ContentProps = {
  isLoading: boolean;
  bulkFeeIntents?: BulkFeeIntent[];
  paginator: React.ReactNode;
};

function Content({ isLoading, bulkFeeIntents, paginator }: ContentProps) {
  if (isLoading) {
    return <BulkFeeIntentsTable bulkFeeIntents={[]} isLoading={isLoading} pageSize={PAGE_SIZE} />;
  }
  if (!bulkFeeIntents?.length) {
    return <OptInPage />;
  }
  return (
    <>
      <BulkFeeIntentsTable bulkFeeIntents={bulkFeeIntents} pageSize={PAGE_SIZE} />
      {paginator}
    </>
  );
}

export const OnDemandBillingIndexPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const offset = (currentPage - 1) * PAGE_SIZE;

  const { data, loading } = useGraphQLQuery(BulkFeeIntentsDocument, {
    variables: { offset, limit: PAGE_SIZE },
    fetchPolicy: 'no-cache',
  });

  const bulkFeeIntents = data?.firm?.bulkFeeIntents;
  const bulkFeeIntentCount = data?.firm?.bulkFeeIntentCount ?? 0;
  const numberOfPages = Math.ceil(bulkFeeIntentCount / PAGE_SIZE);

  const paginator =
    bulkFeeIntentCount > PAGE_SIZE ? (
      <Paginator
        setCurrentPage={setCurrentPage}
        currentPage={currentPage}
        numberOfPages={numberOfPages}
        css={{ mt: 'space.300' }}
      />
    ) : null;

  return (
    <Layout active="billing_plans">
      <Layout.Header>
        <ClientBillingHeader />
      </Layout.Header>
      <Layout.Content>
        <Content isLoading={loading} bulkFeeIntents={bulkFeeIntents} paginator={paginator} />
      </Layout.Content>
    </Layout>
  );
};
